const Content = () => {
    return (
        <div className="text-center text-[#FFFFFF] xl:px-56 xl:pb-12">
            <p className="text-3xl font-normal xl:text-5xl">Why choose Chatme?</p>
            <p className="px-24 py-8 text-base font-normal md:text-base lg:py-4 xl:px-52 xl:py-4">Key features that set it apart from other chatbot platforms</p>
            <div className="flex items-center justify-center pb-7">
                <div className="flex items-center">
                    <div className="h-[0.5px] w-12 bg-[#5AE65E] md:h-[1px]"></div>
                    <div className="w-1 h-1 bg-[#5AE65E] md:w-2 md:h-2" style={{ clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)' }}></div>
                    <div className="h-[0.5px] w-12 bg-[#5AE65E] md:h-[1px]"></div>
                </div>
            </div>
            <p className="hidden w-[950px] text-base font-normal lg:block lg:w-full lg:px-16 xl:text-sm 2xl:px-0 2xl:text-base">
                In the rapidly evolving world of chatbot technology, Chatme has carved out a nique niche for itself.
                Its innovative capabilities and user-friendly design set it apart, making it an excellent choice for 
                businesses aiming to elevate their customer agement strategies. Delve into Zero Chat to discover how 
                it revolutionizes the way companies interact with their customers.
            </p>
        </div>
    );
};

export default Content;